export var getIds = function getIds(id) {
  return id ? {
    root: id,
    dueDateIndicator: "".concat(id, "__due-date-indicator"),
    dueDateIndicatorWrapper: "".concat(id, "__due-date-indicator-wrapper"),
    wrapper: "".concat(id, "__wrapper"),
    colorizer: "".concat(id, "__colorizer"),
    leftSideBackground: "".concat(id, "__left-side-background"),
    rightSideBackground: "".concat(id, "__right-side-background"),
    focus: "".concat(id, "__focus"),
    focusWrapper: "".concat(id, "__focus-wrapper"),
    today: "".concat(id, "__today"),
    todayWrapper: "".concat(id, "__today-wrapper")
  } : undefined;
};
//# sourceMappingURL=getIds.js.map